import React, { ReactNode } from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { Revealer } from '@application/Interfaces/Atoms/Revealer'
import { Description as DescriptionType, ThemeModeType } from '@application/Types/ComponentTypes'
import { Nullable } from '@application/Types/Opt'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import Container from '@mui/material/Container'

import { Content, Description, Subtitle, Title, Wrapper } from './TitleSection.styled'

type TitleSectionType = {
    title: Nullable<string>
    subtitle: Nullable<string>
    description?: Nullable<string | DescriptionType>
    children: ReactNode
    className?: string
    mode?: ThemeModeType
}

export const TitleSection = ({
    title,
    subtitle,
    children,
    className,
    mode = 'Light',
    description,
}: TitleSectionType): JSX.Element => {
    return (
        <Wrapper className={className} $mode={mode}>
            <Container>
                <Grid container>
                    <Revealer
                        multi={{
                            delay: 150,
                        }}
                    >
                        {title && <Title>{title}</Title>}
                        {subtitle && <Subtitle>{subtitle}</Subtitle>}
                        {description && (
                            <Description>
                                {typeof description === 'string' ? (
                                    description
                                ) : (
                                    <Html content={description.data.childMarkdownRemark.html} />
                                )}
                            </Description>
                        )}
                        <Content>{children}</Content>
                    </Revealer>
                </Grid>
            </Container>
        </Wrapper>
    )
}
